import ajax from '@/utils/ajax'

// 获取验证码
// export const sendCode = params => ajax.post('begin/commonSendMsg', params)
export const sendCode = params => ajax.post('login/sendVerificationCode', params)

// 登录（手机号 验证码）
// export const loginByPhone = params => ajax.post('begin/loginAppV4', params)
export const loginByPhone = params => ajax.post('login/verifyLoginByMobile', params)

// 登录（账号 密码）
export const loginByAccount = params => ajax.post('login/verifyLoginByAccount', params)

// ticket自动登录
export const loginByTicket = params => ajax.post('login/loginByTicket', params)

// 用户绑定手机号
export const bindPhone = params => ajax.post('login/accountBindPhone', params)

// 获取菜单权限
export const getMenuList = params => ajax.post('login/getUserResourcePermission', params)

// 是否开启手机号绑定全局提示
export const isShowBindPhoneApi = params => ajax.post('login/getIfBindPhone', params)

// 获取账号列表
export const getAccountList = params => ajax.post('login/getAccountInfos', params)

// 获取跳转地址
export const getLinks = params => ajax.post('login/links', params)

// 获取协议内容
export const getAgreement = params => ajax.post('login/protocolContentByType', params)

// 登录后展示 - 商户通道费变更提示（result 为 null 或 needRead=false 时不弹）
export const getLoginDisplay = params => ajax.get('login/loginDisplay', params)

// 商户确认通道费变更
export const confirmChannelFeeChange = params => ajax.get('login/confirmChannelFeeChange', params)

// 商户通道费变更详情（确认历史/操作记录，入参 { msgId }，取消息列表行 id）
export const queryChannelFeeConfirmHistory = params => ajax.post('login/queryChannelFeeConfirmHistory', params)
